import api from '@/lib/axios'

export interface SEOSettings {
    meta_title: string
    meta_description: string
    meta_keywords: string
    generate_robots_txt: boolean
    generate_sitemap: boolean
}

export interface SocialMedia {
    facebook: string
    twitter: string
    linkedin: string
    instagram: string
    youtube: string
    kariyerNet: string
    show_icons: boolean
}

export interface Analytics {
    google_analytics_id: string
    google_tag_manager_id: string
}

export interface SiteSettings {
    site_name: string
    site_description: string
    contact_email: string
    contact_phone: string
    whatsapp_number: string
    working_hours: string
    address: string
    map_embed_code: string
    about_text: string
    maintenance_mode: boolean
    under_construction: boolean
    default_language: string
    seo_settings: SEOSettings
    social_media: SocialMedia
    analytics: Analytics
    [key: string]: any
}

export const settingsService = {
    // Get all settings mapped into a single object
    getSettings: async (): Promise<SiteSettings> => {
        const response = await api.get<SiteSettings>('/settings')
        return response.data
    },

    // Update a single setting
    updateSetting: async (key: string, value: any) => {
        const response = await api.put(`/settings/${key}`, { value })
        return response.data
    },

    // Batch update multiple settings sequentially
    updateSettingsBulk: async (settingsToUpdate: Record<string, any>) => {
        const promises = Object.entries(settingsToUpdate).map(([key, value]) =>
            api.put(`/settings/${key}`, { value })
        )
        await Promise.all(promises)
    },

    // Initialize defaults if they don't exist
    initializeSettings: async () => {
        const response = await api.post('/settings/initialize')
        return response.data
    }
}
